import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classes from '../analytics.module.scss';
import { RangeDatePicker } from '../../../../_common/Form/DatePickers/RangeDatePicker/RangeDatePicker';
import SelectWithSearch from '../../../../_common/Form/Selects/SelectWithSearch/SelectWithSearch';
import accountHelpers from '../../../../../utils/accountHelpers';
import DOBPicker from '../../../../_common/Form/DatePickers/DOBPicker/DOBPicker';
import Api from '../../../../../api/api';

function AnalyticsChartWrapper({
  children, title, onChange, date, className, calendarMonth, healthValue, setHealthValue, chartWrapperClass,
}) {
  const { healthList } = useSelector((store) => store.healths);

  const [healthOptions, setHealthOptions] = useState(healthList);

  const [searchLoading, setSearchLoading] = useState(false);
  const onChangeHeathSearch = async (value) => {
    setSearchLoading(true);
    setHealthValue(value);

    const { data: { data: { response } } } = await Api.getHealth({
      userId: accountHelpers.getUser().id,
      page: 1,
      name: value,
      limit: 100,
    });


    setHealthOptions(response);
    setSearchLoading(false);
  };

  const changeSelectOption = (option, searchValue) => {
    setHealthValue(searchValue);
    onChange(option, 'healthPlanId', searchValue);
  };

  const chatFilterClass = [classes.wrapper, className];

  return (
    <div className={`${chatFilterClass.join(' ')} ${chartWrapperClass}`}>
      <div className={classes.chart_info}>
        <p className={classes.title}>{title}</p>

        <div className={classes.chart_filter}>
          <div className={classes.select}>
            <SelectWithSearch
              label="Heath plan"
              optionPathname="hubId"
              zIndex={31}
              optionKey="id"
              options={healthOptions}
              searchValue={healthValue}
              onChange={onChangeHeathSearch}
              loading={searchLoading}
              onSelectOption={(option, searchValue) => changeSelectOption(option, searchValue)}
            />
          </div>

          <div className={classes.calendar}>
            {calendarMonth
              ? (
                <DOBPicker
                  date={date.start || ''}
                  showMonth
                  dateFormat="MM-DD-YYYY"
                  onChange={(dateRange) => onChange(dateRange, 'start')}
                />
              )
              : (
                <RangeDatePicker
                  currentDate={date}
                  onChangeDate={(dateRange) => onChange(dateRange, 'date')}
                />
              )}
          </div>
        </div>
      </div>

      {children}
    </div>
  );
}

AnalyticsChartWrapper.protoTypes = {
  children: PropTypes.any.isRequired,
  title: PropTypes.string,
  calendarMonth: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  date: PropTypes.object.isRequired,
  chartWrapperClass: PropTypes.string,
  className: PropTypes.string,
};

AnalyticsChartWrapper.defaultProps = {
  calendarMonth: false,
  chartWrapperClass: '',
  title: '',
  className: '',
};

export default AnalyticsChartWrapper;
